
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/ui-footer/src/footer.less');
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/ui-footer/src/images/lc-logo-blue.svg');